<app-card>
  <app-card-content>
    <div class="flex justify-between items-center" [class.primary]="color === 'primary'">
      @if (icon) {
        @let isIconFromAssets = icon | isIconFromAssets;
        <div class="mr-12 flex items-center left-icon">
          @if (isIconFromAssets) {
            <ion-icon [src]="icon" />
          } @else {
            <ion-icon [name]="icon"></ion-icon>
          }
        </div>
      }
      <div class="flex-1">
        {{ title }}
      </div>
      <ion-icon *ngIf="click.observed && !hideChevron" name="chevron-forward-outline"></ion-icon>
      <div class="text" *ngIf="text">
        {{ text }}
      </div>
    </div>
  </app-card-content>
</app-card>
